module.exports = __webpack_public_path__ + "img/loader_b.fc3e27de.svg";